"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeFiles = exports.updateSettings = exports.updateModifiedTimes = exports.unsetLoadingState = exports.unsetHasSavedChanges = exports.toggleRerenderFlag = exports.setSettings = exports.setPath = exports.setLoadingState = exports.setLoadedFiles = exports.setJustPath = exports.setHasSavedChanges = exports.setHasInitialized = exports.setBasePath = exports.saveSettings = exports.removeNewLocal = exports.removeLocal = exports.loadSettings = exports.loadFiles = exports.initializeFiles = exports.initialState = exports["default"] = exports.copyHash = exports.changeLocalFiles = void 0;
var _reduxActions = require("redux-actions");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _update2 = _interopRequireDefault(require("lodash/update"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _getObjectHash = _interopRequireDefault(require("../helpers/getObjectHash"));
var _appDefsObject = require("./appDefsObject.js");
var _handleActions;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd.boilerplate;

// Initial state
var initialState = exports.initialState = {
  basePath: '',
  path: '',
  files: {},
  hasInitialized: false,
  hasSavedChanges: false,
  loading: true,
  rerenderFlag: false,
  saveSettingsHash: '',
  settings: {},
  settingsHash: ''
};

// Actions
var SET_LOADING_STATE = 'appdefs/gui/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'appdefs/gui/UNSET_LOADING_STATE';
var SET_HAS_INITIALIZED = 'appdefs/gui/SET_HAS_INITIALIZED';
var SET_SETTINGS = 'appdefs/gui/SET_SETTINGS';
var UPDATE_SETTINGS = 'appdefs/gui/UPDATE_SETTINGS';
var SET_HAS_SAVED_CHANGES = 'appdefs/gui/SET_HAS_SAVED_CHANGES';
var UNSET_HAS_SAVED_CHANGES = 'appdefs/gui/UNSET_HAS_SAVED_CHANGES';
var SET_BASE_PATH = 'appdefs/gui/SET_BASE_PATH';
var SET_PATH = 'appdefs/gui/SET_PATH';
var COPY_HASH = 'appdefs/gui/COPY_HASH';
var CHANGE_LOCAL_FILES = 'appdefs/gui/CHANGE_LOCAL_FILES';
var REMOVE_LOCAL = 'appdefs/gui/REMOVE_LOCAL';
var REMOVE_NEW_LOCAL = 'appdefs/gui/REMOVE_NEW_LOCAL';
var SET_LOADED_FILES = 'appdefs/gui/SET_LOADED_FILES';
var UPDATE_MODIFIED_TIMES = 'appdefs/gui/UPDATE_MODIFIED_TIMES';
var TOGGLE_RERENDER_FLAG = 'appdefs/gui/TOGGLE_RERENDER_FLAG';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setHasInitialized = exports.setHasInitialized = (0, _reduxActions.createAction)(SET_HAS_INITIALIZED);
var setSettings = exports.setSettings = (0, _reduxActions.createAction)(SET_SETTINGS);
var updateSettings = exports.updateSettings = (0, _reduxActions.createAction)(UPDATE_SETTINGS);
var setHasSavedChanges = exports.setHasSavedChanges = (0, _reduxActions.createAction)(SET_HAS_SAVED_CHANGES);
var unsetHasSavedChanges = exports.unsetHasSavedChanges = (0, _reduxActions.createAction)(UNSET_HAS_SAVED_CHANGES);
var setBasePath = exports.setBasePath = (0, _reduxActions.createAction)(SET_BASE_PATH);
var setJustPath = exports.setJustPath = (0, _reduxActions.createAction)(SET_PATH);
var copyHash = exports.copyHash = (0, _reduxActions.createAction)(COPY_HASH);
var changeLocalFiles = exports.changeLocalFiles = (0, _reduxActions.createAction)(CHANGE_LOCAL_FILES);
var removeLocal = exports.removeLocal = (0, _reduxActions.createAction)(REMOVE_LOCAL);
var removeNewLocal = exports.removeNewLocal = (0, _reduxActions.createAction)(REMOVE_NEW_LOCAL);
var setLoadedFiles = exports.setLoadedFiles = (0, _reduxActions.createAction)(SET_LOADED_FILES);
var updateModifiedTimes = exports.updateModifiedTimes = (0, _reduxActions.createAction)(UPDATE_MODIFIED_TIMES);
var toggleRerenderFlag = exports.toggleRerenderFlag = (0, _reduxActions.createAction)(TOGGLE_RERENDER_FLAG);
var SETTINGS_MAP = {
  app: 'app.json',
  application: 'application.json',
  assignments: 'assignments.json',
  bulkUpload: 'bulkUpload.json',
  boilerplate: 'boilerplate.json',
  flow: 'flow.json',
  helpCenters: 'helpCenters.json',
  metrics: 'metrics.json',
  pawnData: 'pawnData.json',
  reports: 'reports.json',
  tables: 'tables.json',
  resourceCenters: 'resourceCenters.json',
  reportCenters: 'reportCenters.json',
  routes: 'routes.json',
  sessions: 'sessions.json',
  customTables: 'customTables.json'
};

/* ***************************************************** */
/* ****************** CUSTOM ACTIONS ******************* */
/* ***************************************************** */

var initializeFiles = exports.initializeFiles = function initializeFiles(_ref) {
  var filenames = _ref.filenames,
    projectId = _ref.projectId;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var localState, initializedFiles, alreadyLoadedRequestedFilenames;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            localState = getState().appdefs.gui;
            initializedFiles = Object.keys(localState.files);
            alreadyLoadedRequestedFilenames = Array.isArray(filenames) && filenames.every(function (f) {
              return initializedFiles.includes(f);
            });
            if (!(!localState.hasInitialized && !alreadyLoadedRequestedFilenames)) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return dispatch(loadFiles({
              filenames: filenames,
              projectId: projectId
            }));
          case 1:
            // Only considered initialized if all files are loaded (i.e., no
            // filenames specified)
            if (!filenames) {
              dispatch(setHasInitialized());
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var setPath = exports.setPath = function setPath(_ref3) {
  var path = _ref3.path,
    setPathToUrl = _ref3.setPathToUrl;
  return function (dispatch, getState) {
    dispatch(setJustPath(path));
    if (setPathToUrl) {
      var state = getState().appdefs.gui;
      setPathToUrl(state.path);
    }
  };
};
var loadFiles = exports.loadFiles = function loadFiles(_ref4) {
  var filenames = _ref4.filenames,
    projectId = _ref4.projectId;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var qsfiles, params, response;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(setLoadingState());
            qsfiles = Array.isArray(filenames) ? filenames.join(',') : '';
            params = {};
            if (qsfiles) {
              params.filenames = qsfiles;
            }
            if (projectId) {
              params.projectId = projectId;
            }
            _context2.n = 1;
            return (0, _cccisdAxios["default"])({
              method: 'get',
              url: Boilerplate.route('app.get.bulkConfig'),
              params: params
            });
          case 1:
            response = _context2.v;
            if (!(response.data.status === 'success')) {
              _context2.n = 2;
              break;
            }
            _context2.n = 2;
            return dispatch(setLoadedFiles(response.data.data));
          case 2:
            dispatch(unsetLoadingState());
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var loadSettings = exports.loadSettings = function loadSettings() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var files, settings, settingsKeys, i, key, filename;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            files = getState().appdefs.gui.files;
            settings = {};
            settingsKeys = Object.keys(SETTINGS_MAP);
            i = 0;
          case 1:
            if (!(i < settingsKeys.length)) {
              _context3.n = 4;
              break;
            }
            key = settingsKeys[i];
            filename = SETTINGS_MAP[key];
            if (!files[filename]) {
              _context3.n = 3;
              break;
            }
            _context3.n = 2;
            return JSON.parse(files[filename].contents);
          case 2:
            settings[key] = _context3.v;
          case 3:
            i++;
            _context3.n = 1;
            break;
          case 4:
            _context3.n = 5;
            return dispatch(setSettings(settings));
          case 5:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var saveSettings = exports.saveSettings = function saveSettings() {
  var overwriteAllModified = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var projectId = arguments.length > 1 ? arguments[1] : undefined;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var settings, files, settingsFiles, response;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            settings = getState().appdefs.gui.settings;
            files = getState().appdefs.gui.files;
            settingsFiles = [];
            Object.keys(settings).forEach(function (key) {
              if (settings[key] !== undefined) {
                var contents = JSON.stringify(settings[key], null, 4);
                var filename = SETTINGS_MAP[key];
                var file = files[filename] ? (0, _cloneDeep2["default"])(files[filename]) : null;
                if (file) {
                  // Update the existing file
                  file.contents = contents;
                  settingsFiles.push(file);
                } else {
                  // This file didn't exist before; we will need to create it
                  settingsFiles.push({
                    path: filename,
                    contents: contents
                  });
                }
              }
            });
            if (settingsFiles.length) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2, false);
          case 1:
            _context4.n = 2;
            return dispatch(changeLocalFiles(settingsFiles));
          case 2:
            _context4.n = 3;
            return dispatch(writeFiles(settingsFiles.map(function (f) {
              return f.filename;
            }), overwriteAllModified, projectId));
          case 3:
            response = _context4.v;
            if (response.status === 200 && response.data.status === 'success') {
              dispatch(setHasSavedChanges());
              dispatch(copyHash());
            }
            return _context4.a(2, response);
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var writeFiles = exports.writeFiles = function writeFiles(filenames) {
  var overwriteAllModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var projectId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var existingFiles, files, response;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            existingFiles = getState().appdefs.gui.files;
            files = [];
            if (!(!filenames || filenames.length === 0)) {
              _context5.n = 1;
              break;
            }
            files = Object.values(existingFiles);
            _context5.n = 3;
            break;
          case 1:
            filenames = _filenamesThatMatch(filenames, Object.keys(existingFiles));
            if (filenames.length) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2, false);
          case 2:
            filenames.forEach(function (filename) {
              files.push(existingFiles[filename]);
            });
          case 3:
            _context5.n = 4;
            return _cccisdAxios["default"].post(Boilerplate.route('app.set.bulkConfig'), {
              data: {
                files: files,
                overwriteAllModified: overwriteAllModified,
                projectId: projectId
              }
            });
          case 4:
            response = _context5.v;
            if (response.data && response.data.status === 'success') {
              dispatch(updateModifiedTimes(response.data.data.files));
              dispatch((0, _appDefsObject.setAppDefsObject)(response.data.data.appDefsObject));
            }
            return _context5.a(2, response);
        }
      }, _callee5);
    }));
    return function (_x9, _x0) {
      return _ref8.apply(this, arguments);
    };
  }();
};

/* ***************************************************** */
/* ********************** HELPERS ********************** */
/* ***************************************************** */

var _escapeRegExp = function _escapeRegExp(s) {
  s = s.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');
  return s.replace(new RegExp('\\*', 'g'), '.*');
};
var _filenamesThatMatch = function _filenamesThatMatch(filenames, existingFilenames) {
  var filenamesThatMatch = [];
  filenames.forEach(function (filename) {
    if (filename) {
      var filenameRegexReady = _escapeRegExp(filename);
      var matching = existingFilenames.filter(function (efilename) {
        return efilename.match("^".concat(filenameRegexReady, "$"));
      });
      filenamesThatMatch = filenamesThatMatch.concat(matching);
    }
  });
  return _toConsumableArray(new Set(filenamesThatMatch));
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), CHANGE_LOCAL_FILES, function (state, action) {
  var updatedFiles = Object.assign({}, state.files);
  if (action.payload && action.payload.length) {
    action.payload.forEach(function (file) {
      file.hasChanged = true;
      updatedFiles[file.filename] = file;
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), REMOVE_LOCAL, function (state, action) {
  var filesToCheck = action.payload || false;
  if (filesToCheck) {
    filesToCheck = Array.isArray(filesToCheck) ? filesToCheck : [filesToCheck];
  }
  var updatedFiles = Object.assign({}, state.files);
  if (filesToCheck.length) {
    filesToCheck = _filenamesThatMatch(filesToCheck, Object.keys(updatedFiles));
    filesToCheck.forEach(function (filename) {
      delete updatedFiles[filename];
    });
  } else {
    updatedFiles = {};
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), REMOVE_NEW_LOCAL, function (state, action) {
  var filesToCheck = action.payload || false;
  if (filesToCheck) {
    filesToCheck = Array.isArray(filesToCheck) ? filesToCheck : [filesToCheck];
  }
  var updatedFiles = Object.assign({}, state.files);
  if (filesToCheck.length) {
    filesToCheck = _filenamesThatMatch(filesToCheck, Object.keys(updatedFiles));
    filesToCheck.forEach(function (filename) {
      if (!updatedFiles[filename].modified) {
        delete updatedFiles[filename];
      }
    });
  } else {
    Object.keys(updatedFiles).forEach(function (filename) {
      if (!updatedFiles[filename].modified) {
        delete updatedFiles[filename];
      }
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), SET_LOADED_FILES, function (state, action) {
  var updatedFiles = Object.assign({}, state.files);
  if (Array.isArray(action.payload) && action.payload.length) {
    action.payload.forEach(function (file) {
      updatedFiles[file.filename] = file;
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), SET_HAS_INITIALIZED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasInitialized: true
  });
}), SET_SETTINGS, function (state, action) {
  var hash = (0, _getObjectHash["default"])(action.payload);
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: action.payload,
    settingsHash: hash,
    savedSettingsHash: hash
  });
}), UPDATE_SETTINGS, function (state, action) {
  var _action$payload = action.payload,
    path = _action$payload.path,
    settings = _action$payload.settings;
  var newSettings = (0, _cloneDeep2["default"])(state.settings);
  if (path === '') {
    newSettings = _objectSpread(_objectSpread({}, newSettings), settings);
  } else {
    (0, _update2["default"])(newSettings, path, function (obj) {
      if ((0, _isArray2["default"])(settings)) {
        return settings;
      }
      return _objectSpread(_objectSpread({}, obj), settings);
    });
  }
  var hash = (0, _getObjectHash["default"])(newSettings);
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: newSettings,
    settingsHash: hash
  });
}), SET_HAS_SAVED_CHANGES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasSavedChanges: true
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, UNSET_HAS_SAVED_CHANGES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasSavedChanges: false
  });
}), SET_BASE_PATH, function (state, action) {
  if (action.payload === state.basePath) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    basePath: action.payload
  });
}), SET_PATH, function (state, action) {
  var path = action.payload;
  var currentPath = state.path;

  // absolute path starts with '/'
  if (/^\//.test(path)) {
    path = path.substring(1);
  } else if (currentPath !== '') {
    if (/^\[/.test(path)) {
      path = currentPath + path;
    } else {
      path = currentPath + '.' + path;
    }
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    path: path
  });
}), COPY_HASH, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedSettingsHash: state.settingsHash
  });
}), UPDATE_MODIFIED_TIMES, function (state, action) {
  if (!action.payload) {
    return state;
  }
  var updatedFiles = Object.assign({}, state.files);
  if (action.payload.length) {
    action.payload.forEach(function (file) {
      updatedFiles[file.filename].modified = file.modified;
      updatedFiles[file.filename].hasChanged = false;
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), TOGGLE_RERENDER_FLAG, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    rerenderFlag: !state.rerenderFlag
  });
})), initialState);